import React from 'react';
import PropTypes from 'prop-types';
import LocationIcon from '../../../../../icons/icon-location.svg';


export default function TriggerDisclaimer({
  action,
  programName,
  location,
}) {
  const region = location ? location.region : '';

  return (
    <>
      {`Your current selected ${programName} service location is`}
      <span className="opco-navigator__disclaimer-icon">
        &nbsp;
        <LocationIcon />
        &nbsp;
      </span>
      {`${region}. If you need to `}
      <span
        tabIndex="0"
        role="button"
        className="opco-navigator__disclaimer-link"
        onClick={action}
        onKeyPress={action}
      >
        update your location
      </span>
      &nbsp;it will retain any available items and take you to the cart.
    </>
  );
}

TriggerDisclaimer.propTypes = {
  action: PropTypes.func.isRequired,
  programName: PropTypes.string.isRequired,
  location: PropTypes.oneOfType([
    PropTypes.shape({
      region: PropTypes.string,
    }),
    PropTypes.string,
  ]).isRequired,
};
